// A page image that fails to load renders its alt text in an empty tinted box.
// The server swaps URLs that are dead when a section is saved for the
// placeholder (AI.SectionBody); this covers the ones that die afterwards, the
// same way, so a set of cards keeps one anatomy and the slot stays editable.
const PLACEHOLDER = "/images/placeholder.svg";

const swap = (img) => {
  if (img.getAttribute("src") === PLACEHOLDER) return;
  img.setAttribute("data-placeholder", "");
  img.setAttribute("src", PLACEHOLDER);
};

const broken = (img) =>
  img.tagName === "IMG" && img.closest(".ai-page-content") && img.getAttribute("src");

document.addEventListener("error", (e) => broken(e.target) && swap(e.target), true);

// Module scripts run after parsing, so images that already failed fired their
// error event before the listener existed. An SVG with no intrinsic size can
// report naturalWidth 0 while rendering fine, so it is left alone.
document
  .querySelectorAll(".ai-page-content img")
  .forEach(
    (img) =>
      broken(img) &&
      img.complete &&
      img.naturalWidth === 0 &&
      !/\.svg(\?|#|$)/i.test(img.src) &&
      swap(img),
  );
